export default __webpack_public_path__ + "befe312b59312dd3c86d76d81e664b20.jpg";